module.exports = __webpack_public_path__ + "static/media/6.619ddd01.png";